import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "react-feather";
import Axios from "axios";
import { NavLink } from "react-router-dom";

// Components

import TitleBox from "../../components/TitleBox";
import Buttons from "../../components/Buttons";
import Footer from "../../components/Footer";
import citiesData from "../../components/data/citiesData.json";

// CSS

import "../css/Hospitals.scss";

const Hospitals = ({ setHospitalProps, providerType, providerTypeName }) => {
  let navigate = useNavigate();

  const [height, setHeight] = useState(window.innerHeight);
  const [width, setWidth] = useState(window.innerWidth);
  const [locationData, setLocationData] = useState([]);

  const [titleBoxName, setTitleBoxName] = useState("");

  window.addEventListener("resize", function () {
    setWidth(window.innerWidth);
    setHeight(window.innerHeight);
  });

  const config = {
    headers: {
      Authorization:
        "Bearer O-fzs9I-hE4Y1zShZxYVXiIHVGHzPrmY6pcpYXqMNiZXeS9FoVngizjjIpPNu9ezaX7Q0iEkhcUKDcCRoPI6CLpBJTg57c_wWGX7A9aRv4_8zgqC8OMJfyfh1wQbcy89aStEZgt_YX75ZIUp12pU_pUV5UXw4jPsYm4sLb7Uxbw0xe5vmwSkEpWYqtUaRHYdA7mvEM7kg24rN7ZaDybjAShOgV12udX-53iN7rMRBWWbf8NO9QHMmlACrSlYqF07wrQvw16VzhtVnR1DOe7ZVV04SreQFSMOVzxH9OzLDgCoV73bIvJ23oS_7cTC9PuXzyYafix0gF_BSnCvXNYn-voS8yao26FfKufEiW5w63fkhGUpakuTd2BM3aHPO18oA-fRuvgbwdCpopm2BtwoGA",
    },
  };

  const url = "https://webkit.toplogic.com.ph:9080/getnrccities";

  const getLocationData = async () => {
    await Axios.get(url, config)
      .then((res) => {
        setLocationData(res.data.data);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  useEffect(() => {
    // getLocationData();

    switch (providerType) {
      case "H":
        setTitleBoxName("Hospitals");
        break;
      case "C":
        setTitleBoxName("Medical Clinics");
        break;
      default:
        setTitleBoxName("Dental Clinics");
        break;
    }
  }, []);

  const handleClick = (citycode, cityname) => {
    setHospitalProps({
      citycode: citycode,
      cityname: cityname,
      providertype: providerType,
      providertypename: providerTypeName,
    });
  };

  return (
    <>
      <div
        className='hospitals-container'
        style={{
          height: height - 75,
          width: width,
        }}
      >
        <TitleBox title={titleBoxName} />
        <Buttons
          text={<ArrowLeft />}
          onClick={() => navigate(-1)}
          color='primary'
          style={{
            height: "5px !important",
            position: "absolute",
            top: "5%",
            left: 0,
            borderRadius: "0px 10px 10px 0px",
            padding: "1% 2.5%",
            zIndex: 9,
          }}
        />

        <div className='main-location-list'>
          {citiesData.map((cities, index) => {
            return (
              <NavLink
                to={`/providers/${providerTypeName}/list`}
                className='loc-list-item'
                onClick={() => handleClick(cities.citycode, cities.cityname)}
                key={cities.citycode}
              >
                {cities.cityname}
              </NavLink>
            );
          })}
        </div>

        <Footer args={{ height, width }} />
      </div>
    </>
  );
};

export default Hospitals;
